/** Percent extra Norwegian tokens compared to English, rounded to nearest int. Null if EN is zero. */
export function premiumPct(noTokens: number, enTokens: number): number | null {
  if (enTokens === 0) return null;
  return Math.round(((noTokens - enTokens) / enTokens) * 100);
}
